import { AntDesign } from "@expo/vector-icons";
import { Colors, TouchableOpacity, View } from "react-native-ui-lib";
import { Pagination } from "../../../../../../components";
import { useLayoutProvider } from "../../../../utils/layout";

export function QuickListPagination() {
  const { isEditing, pagesController } = useLayoutProvider();

  const { currentPage, pages, addEmptyPage, goToNextPage, goToPage } =
    pagesController;

  const totalPages = pages.length;

  const paginationExtraMarkup = isEditing ? (
    <TouchableOpacity
      onPress={addEmptyPage}
      style={{
        borderRadius: "50%",
        backgroundColor: Colors.neutralButton,
        margin: 6,
      }}
    >
      <AntDesign name="pluscircleo" size={24} color={Colors.$iconPrimary} />
    </TouchableOpacity>
  ) : null;

  const showPagination = isEditing || totalPages > 1;

  const paginationMarkup = showPagination ? (
    <Pagination
      currentPage={currentPage}
      totalPages={totalPages}
      goToPage={goToPage}
      endAdornment={paginationExtraMarkup}
    />
  ) : null;

  return (
    <View style={{ display: "flex", flexShrink: 0 }}>{paginationMarkup}</View>
  );
}
